import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import AuthPanel from "./AuthPanel";
import { finishSignIn, useSignInDialog } from "./signInDialogState";
import "./SignInDialog.css";

/** One host for every story/world entry point; authentication stays in AuthPanel. */
export function SignInDialog() {
  const request = useSignInDialog((state) => state.request);
  const location = useLocation();
  // A dialog belongs to the page that opened it, including any unsaved draft there.
  useEffect(
    () => () => {
      const pending = useSignInDialog.getState().request;
      if (pending) finishSignIn(pending, false);
    },
    [location.key]
  );
  if (!request) return null;
  const title = request.title || "Sign in to Unique Minds";
  const description =
    request.description ||
    "Keep your stories, worlds, and characters together in your account.";
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) finishSignIn(request, false);
      }}
    >
      <DialogContent
        overlayClassName="sign-in-overlay"
        className="sign-in-dialog max-w-md rounded-2xl bg-gradient-to-b from-purple-50 to-white pt-10 text-slate-900"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          if (request.trigger?.isConnected) request.trigger.focus();
        }}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{description}</DialogDescription>
        <AuthPanel
          title={title}
          description={description}
          enableAppDownloadPrompt={false}
          policyLinksInNewTab
          onAuthenticated={() => {
            finishSignIn(request, true);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
